import * as React from "react";

function SvgEnded(props) {
  return <svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><circle cx={15} cy={15} r={15} fill="#E0E4E9" /><g style={{
      mixBlendMode: "multiply"
    }}><circle cx={15} cy={15} r={14.5} fill="#7600D5" /><circle cx={15} cy={15} r={14.5} stroke="#EEEDED" /></g><path fillRule="evenodd" clipRule="evenodd" d="M6.091 16.838a1.456 1.456 0 012.018-2.099l3.005 2.89a2 2 0 002.772 0l9.005-8.659a1.455 1.455 0 112.018 2.098l-11.023 10.6a2 2 0 01-2.772 0l-5.023-4.83z" fill="#fff" /></svg>;
}

export default SvgEnded;